import { css } from "@emotion/react";

export const tabs = css`
  width: 100%;
  min-height: inherit;
`;
